import type { LandingHeaderDomainsNavigation } from '@/client/catalogs/landing/pageContent';
import { EMPTY_PUBLISHED_NEWS_MENU_PREVIEW } from '@uniquedomains/components/contracts/news/public';
import type { HomeDomainsPreviewData } from '@/client/pages/landing/lib/homeDomainsPreview';

export type Links = {
    productAppraise: string;
    productBaseUrl: string;
    productDomains: string;
    trendingDomains: string;
    businessIdeas: string;
    productRadars: string;
    productSearch: string;
    productVerify: string;
    productWatchlists: string;
    createRadar: string;
    screener: string;
    solutionFounder: string;
    solutionInvestor: string;
    solutionStudio: string;
    solutionFounderSignup: string;
    solutionInvestorSignup: string;
    solutionStudioSignup: string;
    signIn: string;
    apiDocs: string;
    compare: string;
    glossary: string;
    newsletter: string;
    pricing: string;
    freeTools: string;
    github: string;
    githubLists: string;
};

export type LandingStats = {
    totalDomains: number;
    totalTlds: number;
    /**
     * Names actually checked in the last 24 hours.
     *
     * Replaces the data-points tile, which multiplied the domain count by a fixed number of fields.
     * The tile now links to a page that publishes measured counts, so the tile has to be one.
     */
    checkedLast24h: number;
    totalSignups: number;
    scannedToday: number;
    updatedToday: number;
    /** When the snapshot behind these figures was taken; `null` before the first one. */
};

export type InitialData = {
    stats: LandingStats;
    links: Links;
    navigation: LandingHeaderDomainsNavigation;
    /** Home's real row preview (ADR-0028 amendment); null hides the section. */
    domainsPreview: HomeDomainsPreviewData | null;
};

export const EMPTY_LANDING_NAVIGATION: LandingHeaderDomainsNavigation = {
    tlds: [],
    sectors: [],
    news: EMPTY_PUBLISHED_NEWS_MENU_PREVIEW,
};
